import { render } from "./Timestamp.vue?vue&type=template&id=088a4540"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__